var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLearningResourcesSelected({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#002648"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.52344 13.6082V11.5L11.5234 12.1667L22.998 15.9915V35.8698V38L20.998 37.2667L9.52344 33.0593V13.6082ZM11.5234 31.6624V14.2749L20.998 17.433V35.1365L11.5234 31.6624ZM36.4726 13.6082V11.5L34.4726 12.1667L22.998 15.9915V35.8698V38L24.998 37.2667L36.4726 33.0593V13.6082ZM24.998 35.1365L34.4726 31.6624V14.2749L24.998 17.433V35.1365ZM18.998 20L12.998 18L13.3142 17.0513L19.3142 19.0513L18.998 20ZM32.998 18L26.998 20L26.6818 19.0513L32.6818 17.0513L32.998 18ZM18.998 26L12.998 24L13.3142 23.0513L19.3142 25.0513L18.998 26ZM32.998 24L26.998 26L26.6818 25.0513L32.6818 23.0513L32.998 24ZM18.998 32L12.998 30L13.3142 29.0513L19.3142 31.0513L18.998 32ZM32.998 30L26.998 32L26.6818 31.0513L32.6818 29.0513L32.998 30Z",
    fill: "#FF6E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearningResourcesSelected);
export default __webpack_public_path__ + "static/media/learning-resources-selected.0afe5e0f74ba9f1d5248da9b7747a9ba.svg";
export { ForwardRef as ReactComponent };